import { useEffect } from "react";
import { useLanguage } from "../contexts/LanguageContext";

export const SITE_URL = "https://www.lucacelart.com";

const OG_LOCALES = { en: "en_US", ro: "ro_RO" };

const setAttr = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

// Keeps <title>, description, canonical and social tags in sync with the current page
// and language. The static defaults for each page are written into the built HTML by
// scripts/seo-prerender.mjs, so crawlers that don't run JavaScript get them too.
export default function usePageMeta(page, path) {
  const { t, language } = useLanguage();
  const title = t(`seo.${page}.title`);
  const description = t(`seo.${page}.description`);

  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('meta[property="og:locale"]', "content", OG_LOCALES[language]);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);
  }, [title, description, path, language]);
}
